import { Link } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { Reveal } from "@/components/Reveal";
import { useSeo } from "@/hooks/useSeo";
import { ArrowRight } from "lucide-react";

const LINKS = [
  { to: "/", label: "Home" },
  { to: "/start-your-journey", label: "Start Your Journey" },
  { to: "/ReadyToBook", label: "Ready To Book" },
  { to: "/Thailand2027", label: "Thailand 2027" },
  { to: "/experiences", label: "Experiences" },
  { to: "/contact", label: "Contact" },
];

export default function NotFound() {
  useSeo({ title: "Page Not Found | Inforno Travel", description: "The page you're looking for doesn't exist. Explore Inforno Travel's luxury group travel experiences instead.", noindex: true });
  return (
    <div className="bg-noir min-h-screen flex flex-col">
      <Navbar />
      <section data-testid="not-found-page" className="flex-1 flex items-center px-6 md:px-12 py-32">
        <div className="max-w-[1500px] mx-auto w-full">
          <Reveal>
            <p className="font-body text-[11px] uppercase tracking-[0.45em] text-gold mb-6">Error 404</p>
            <h1 className="font-serif font-light tracking-tighter leading-[0.92] text-6xl sm:text-8xl text-ink max-w-3xl">This page has wandered <span className="italic text-gold">off the map.</span></h1>
            <p className="font-body text-white/60 mt-8 max-w-xl text-base leading-relaxed font-light">
              The page you're looking for doesn't exist or may have moved. Let's get you back on course.
            </p>
            <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-px bg-white/10 border border-white/10 max-w-3xl">
              {LINKS.map((l) => (
                <Link key={l.to} to={l.to} data-testid={`notfound-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                  className="group bg-noir px-6 py-5 flex items-center justify-between font-body text-xs uppercase tracking-[0.22em] text-white/70 hover:text-gold transition-colors">
                  {l.label} <ArrowRight size={14} className="text-gold group-hover:translate-x-1 transition-transform" />
                </Link>
              ))}
            </div>
          </Reveal>
        </div>
      </section>
      <Footer />
    </div>
  );
}
